export default {
    getNewsletterSubState: (state) => {
        return state.isSubscribed;
    },
};
